// import toast from '@/mixins/toast'

const error = {
	code: 2,
	message: '',
	type: ''
}

export default {
	parseErrorFromResult(response) {
		const apiError = Object.assign({},error);

    if (!response) {
      //返回值為空表示發生未知錯誤
      apiError.code = -1;
      apiError.message = '未知錯誤';
			apiError.type = 'unknow';
			return apiError;
		} 

		const result = response.data;
		if (result.code == 1) {
			//code = 1 說明未登入,需要登入
      apiError.code = 1;
      apiError.message = result.message;
			apiError.type = 'nologin';
    } else {
      //返回值不為空就屬於業務錯誤
      apiError.code = result.code;
      apiError.message = result.message;
			apiError.type = 'business'
		}

		return apiError;
	},

	parseError(err) {
		let netError = Object.assign({},error);
		netError.code = -2;
		netError.type = 'network';
		if (!err.response) {
			netError.message = err.message.indexOf('timeout') !== -1 ? '請求超時' : '請求資料失敗';
		} else {
			const code = err.response.status //http狀態碼
			if (code >= 300 && code < 400) {
				netError.message = '資源已被重定向';
			} else if (code >= 400 && code < 500) {
				netError.message = '請求資源不存在';
			} else {
				netError.message = '伺服器內部錯誤';
			}
		}

		return netError;
	},

	showError(error) {
		// toast.showError(error.message)
		if (error.code === 1) {
			// window.location = '/login';
		}
	}
}